import {inject, Injectable} from '@angular/core';
import {
  cloneDeep,
  forEach,
  get,
  has,
  includes,
  isEmpty, isEqual,
  isNull,
  keys,
  replace,
  set,
  split, startsWith,
  toNumber
} from "lodash-es";
import {getClonedObject, isValidXFrameUrls} from "@wm/core";
import {ProfileApiService} from "@wms/settings/profile-configuration";
import {BaseComponent} from "@wms/components";
import {ProjectService} from "@wms/services";
import {NotificationService} from "@wms/services";

@Injectable()
export class ProfileService extends BaseComponent{

  infoMap: any;
  securityInfo: any;
  selectedTab: string;
  isSystemProfile: any;
  dpService: ProfileApiService;
  PROFILES = {
    DEVELOPMENT: 'development',
    DEPLOYMENT: 'deployment'
  }
  FORM_NAME = 'profileInfoForm';
  CORS_PROPERTIES = ["cors.enabled", "cors.allowCredentials", "cors.maxAge"];
  DEFAULT_NODE_MAX_MEMORY = '1024';
  activeProfile: any;
  activeTarget: any;
  appEnvironment: any = {};
  errorKey: boolean;
  errorValue: boolean;
  existingParameters: any;
  isDisableSave: boolean;
  hasImportedDatabases: any;
  hasImportedRests: any;
  hasImportedWebSockets:any;
  hasOAuth2Services: any;
  hasSecurity: number;
  hasAppEnvironmentParameters: any;
  developmentMode: any;
  NodeArgs: string[];
  buildOptions: any = [];
  isSessionPersistenceTypeRedis: boolean;
  isSessionPersistenceTypeJDBC: boolean;
  isSessionPersistenceTypeMongodb: boolean;
  corsEntries: {[key: string]: any} = {};
  openId: any;
  metadataFile: any;
  oldValue: any;
  deployedUrl: string = '';
  _suffix: string;
  _prefix: string;
  _prefix_jndi: string;
  _suffix_jndi: string;
  prevUrl: any;
  prevjndiName: any;
  message: any;
  dbUrl: any = [];
  databaseInfo: {[key: string]: any};
  restInfo: {[key: string]: any};
  websocketInfo: {[key: string]: any};
  override projectService: ProjectService;
  deployInProgress: any;
  appEnvironmentInfo: {[key: string]: any};
  newappEnvironmentParamsList: any = {};
  notificationService: NotificationService;
  appEnvironmentProperties: any ={};
  oauthInfo: {[key: string]: any};
  appEnvironmentUpdated: any = false;
  modeOptions = [{
    'label': this.locale.LABEL_ANGULAR_BUILD_MODE_WM,
    'value': 'wm'
  }, {
    'label': this.locale.LABEL_ANGULAR_BUILD_MODE_ANGULAR,
    'value': 'angular'
  }];
  angularBuildOptions = [{
    'label': this.locale.LABEL_ANGULAR_BUILD_TYPE_DEV,
    'value': '--c=development'
  }, {
    'label': this.locale.LABEL_ANGULAR_BUILD_TYPE_PROD,
    'value': '--c=production'
  }];
  storedInfoMap: any;
  projectDetails: any;
  isPrefabType: boolean = false;
  mode: string;
  leaveProfileRoute = false;
  jndiName:any = []
  isPrism: boolean;
  constructor() {
    super();
    this.dpService = inject(ProfileApiService);
    this.notificationService = inject(NotificationService);
    this.projectDetails = this.projectService.getDetails();
    this.dpService._profileMap = {};
    this.isPrism=this.projectService.isPrism();
      if (this.isPrism) {
          this.modeOptions.push({
              label: this.locale.LABEL_REACT_BUILD_MODE,
              value: 'react'
          });
      }
  }

  selectProfile(profileObj: any) {
    this.isPrefabType = profileObj?.targetName ? true: false;
    this.getProfile(profileObj.profile, profileObj?.targetName);
  }

  private getProfile(profileName: any, targetName?: any,isSave?: any) {
    this.isSystemProfile = this.systemProfile(profileName);
    if (profileName === 'development') {
      //Along with development profile fetch devstudio profile when the selected profile is development in order to mark the imported apis using mock data
      this.dpService.getProfile(profileName, isSave).then((selectedProfile)=>{
        let devStudioProfile: any;
        this.dpService.getProfile('devstudio', isSave).then((profile) => {
          devStudioProfile = profile;
          this.prepareProfileForDisplay(targetName, selectedProfile, devStudioProfile);
        })
      })
    } else {
      this.dpService.getProfile(profileName, isSave).then((profile)=>{
        this.prepareProfileForDisplay(targetName, profile);
      })
    }
  }

  private prepareProfileForDisplay(targetName: any, profile: any, devStudioProfile?: any) {
    this.activeProfile = profile;

    let props = profile.profileProperty,
      entryName,
      securityProviders: any,
      openIdProvider;

    this.infoMap = this.dpService.getInfoMap(props, targetName);
    this.restInfo = this.infoMap.rest;
    this.websocketInfo = this.infoMap.websocket;
    this.appEnvironmentInfo = this.infoMap?.app?.environment;
    this.oauthInfo = this.infoMap.oauth2;
    this.securityInfo = this.infoMap.security;
    if (this.infoMap.db) {
      this.dbUrl = []
      this.jndiName = []
      Object.keys(this.infoMap.db).forEach((key)=>{
        const value = this.infoMap.db[key];
        if (!this.infoMap.db[key].schemaName){
          this.infoMap.db[key].schemaName = {};
          this.infoMap.db[key].schemaName.value = '';
        }
        if(value.url){
          this.registerWatchOnDBConnURL(value.url, key);
        }
        this.registerWatchOnJNDI(value.jndiName)
      })
    }
    if (this.infoMap && this.infoMap.db) {
      this.databaseInfo = Object.fromEntries(
          Object.entries(this.infoMap.db)
          .filter(([key, value]) => (value as { url?: string }).url !== undefined)
      );
    }

    this.appEnvironmentUpdated = false;
    if (devStudioProfile) {
      let devStudioInfoMap: any = this.dpService.getInfoMap(devStudioProfile.profileProperty),
        mockedServices = keys(devStudioInfoMap.rest);
      forEach(this.infoMap.rest, (properties: any, restName: any) =>{
        properties.isMockEnabled = includes(mockedServices, restName);
      });
    }

    this.storedInfoMap = cloneDeep(this.infoMap)
    set(this.appEnvironment, 'key', '');
    set(this.appEnvironment, 'value', '');
    this.errorKey = false;
    this.errorValue = false;
    this.existingParameters = ((this.infoMap && this.infoMap.app && this.infoMap.app.environment) ? getClonedObject(this.infoMap.app.environment) : {});
    this.isDisableSave = true;
    this.hasImportedDatabases = this.infoMap.db && Object.keys(this.infoMap.db).length;
    this.hasImportedRests = this.infoMap.rest && Object.keys(this.infoMap.rest).length? true: false;
    this.hasOAuth2Services = this.infoMap.oauth2 && Object.keys(this.infoMap.oauth2).length;
    this.hasSecurity = this.infoMap.security && Object.keys(this.infoMap.security).length;
    this.hasImportedWebSockets = this.infoMap.websocket && Object.keys(this.infoMap.websocket).length;
    this.hasAppEnvironmentParameters = has(this.infoMap, ['app','environment']) && Object.keys(this.infoMap.app.environment).length>0;
    this.developmentMode = {
      'isDisabled': profile.id === 'development',
      'rememberMeTimeout': get(this.infoMap, 'security.general["rememberMe.timeOut"].value') / 86400,
      'tokenValidity': get(this.infoMap, 'security.general["tokenService.tokenValiditySeconds"].value') / 60
    };
    this.NodeArgs = get(this.infoMap,'build.ui.node.args.value','').split('=');
    this.buildOptions = {
      mode: get(this.infoMap, 'build.ui.mode.value', 'angular'),
      angularBuildType: get(this.infoMap, 'build.ui.ng.config.value', '--c=production'),
      nodeMaxMemory: this.NodeArgs.length>1?this.NodeArgs[1]:this.DEFAULT_NODE_MAX_MEMORY,
    };
    this.mode = this.buildOptions.mode;
    this.isSessionPersistenceTypeRedis = get(this.infoMap,'security.session["persistence.type"].value') === "redis";
    this.isSessionPersistenceTypeJDBC = get(this.infoMap,'security.session["persistence.type"].value') === "jdbc";
    this.isSessionPersistenceTypeMongodb = get(this.infoMap,'security.session["persistence.type"].value') === "mongodb";

    securityProviders = get(this, 'infoMap.security.providers');

    // get the deployed url if the active provider is SAML or OPENID and populate the application redirect url.
    if(includes(['SAML', 'OPENID'], this.infoMap.security?.activeProviders) && profile.id === this.PROFILES.DEPLOYMENT && !this.deployedUrl) {
      this.updateDeployUrl();
    } else if (this.hasOAuth2Services) {
      this.updateDeployUrl();
    }

    if (this.hasSecurity && securityProviders) {
      if (securityProviders.cas) {
        //oldValue is the serverUrl of CAS security provider.
        this.oldValue = securityProviders.cas.serverUrl.value;
      }
      if (securityProviders.saml) {
        this.metadataFile = replace(securityProviders.saml.idpMetadataFile.value, '/saml/metadata/', '');
        if (this.infoMap.security.providers.saml.maxAuthenticationAge.value) {
          this.infoMap.security.providers.saml.maxAuthenticationAge.value = toNumber(this.infoMap.security.providers.saml.maxAuthenticationAge.value);
        }
      }

      // get the active openid provider and assign it to the providers list.
      openIdProvider = get(securityProviders.openId, 'activeProviders');
      if (openIdProvider) {
        this.openId = {
          provider: openIdProvider.value
        };
      }


    }
    if (this.hasSecurity && this.infoMap.security.general && this.infoMap.security.general) {
      forEach(keys(this.infoMap.security.general), (entry: any)=> {
        if (entry.startsWith('cors.') && !includes(this.CORS_PROPERTIES, entry)) {
          entryName = split(this.infoMap.security.general[entry].name, '.');
          this.corsEntries[entryName[4]] = this.infoMap.security.general[entry];
        }
      });
    }
    if (this.infoMap.db) {
      forEach(this.infoMap.db, (database) => {
          database.maxPageSize? database.maxPageSize.value = toNumber(database.maxPageSize.value) : undefined;
          database.maxPoolSize? database.maxPoolSize.value = toNumber(database.maxPoolSize.value) : undefined;
          database.minPoolSize? database.minPoolSize.value = toNumber(database.minPoolSize.value) : undefined;
      });
    }
    if (get(this.infoMap, 'security.general["frameOptions.enabled"].value') === "true" && get(this.infoMap, 'security.general["frameOptions.mode"].value') === 'ALLOW_FROM' && !isValidXFrameUrls(get(this.infoMap, 'security.general["frameOptions.allowFromUrl"].value')) && this.activeProfile.id === 'development' ) {
      this.showErrorMsg('MESSAGE_ERROR_ENTER_VALID_URL_X_FRAME');
    }else{
      this.hideMessage()
    }
  }

  registerWatchOnDBConnURL(nv: any, key: any) {
    let url = nv.value,
      fIndex = url.indexOf(':'), // find the first index of ':'
      sIndex = url.indexOf(':', fIndex + 1); // find the second index of ':'
    // connection url till the second colon(:) should not be editable. save it in _prefix. Save rest of the url in _suffix.
    // _prefix is NOT editable.
    // when _suffix is modified update the corresponding conn url.

    let obj = {
      prefix: url.substring(0, sIndex + 1),
      suffix: url.substring(sIndex + 1)
    }
    this.dbUrl.push(obj);
  }

  systemProfile(profileName: any) {
    return profileName === 'development' || profileName === 'deployment';
  }

  hasProvider(prop: any) {
    return includes(Object.keys(this.infoMap.security.providers), prop);
  }

  updateProfile(resolve: any, reject: any) {
    if (get(this.infoMap, ['security', 'general', 'rememberMe.timeOut'])) {
      this.infoMap.security.general['rememberMe.timeOut'].value = this.developmentMode.rememberMeTimeout*86400;
    }

    set(this.infoMap, 'security.general["tokenService.tokenValiditySeconds"].value', this.developmentMode.tokenValidity * 60);
    this.hideMessage();
    if(!this.validateProfile()) return
    if(!this.isPrefabType) {
      const truststoreType = this.infoMap.security.general['truststore.config'].value;
      const isTruststoreEnabled = truststoreType === 'APPLICATION_ONLY' || truststoreType === 'APPLICATION_AND_SYSTEM';
      const truststoreFile = this.infoMap.security.general['truststore.file'].value;

      this.infoMap.security.general['truststore.fileType'].value = isTruststoreEnabled ? this.infoMap.security.general['truststore.fileType'].value : '';
      this.infoMap.security.general['truststore.password'].value = isTruststoreEnabled ? this.infoMap.security.general['truststore.password'].value : '';
      this.infoMap.security.general['truststore.file'].value = isTruststoreEnabled ? (truststoreFile.startsWith('classpath:') ? truststoreFile : 'classpath:' + truststoreFile) : '';

      const isMtlsEnabled = this.infoMap.security.general['mtls.enabled'].value === 'true';
      const keystoreFile = this.infoMap.security.general['mtls.keystore.file'].value;

      this.infoMap.security.general['mtls.keystore.fileType'].value = isMtlsEnabled ? this.infoMap.security.general['mtls.keystore.fileType'].value : '';
      this.infoMap.security.general['mtls.keystore.password'].value = isMtlsEnabled ? this.infoMap.security.general['mtls.keystore.password'].value : '';
      this.infoMap.security.general['mtls.keystore.file'].value = isMtlsEnabled ? (keystoreFile.startsWith('classpath:') ? keystoreFile : 'classpath:' + keystoreFile) : '';
    }
    if(this.appEnvironmentUpdated) {
      this.updateAppEnvironmentProfile(resolve, reject);
    } else {
      (this.dpService.updateProfile(this.activeProfile.id, this.activeProfile) as Promise<any>).then(()=>{
        resolve();
        if(this.leaveProfileRoute) {
          return;
        }
        const targetName = (this.activeTarget.type === this.dpService.PROFILE_TYPE.PREFAB) ? this.activeTarget.name : undefined;
        this.getProfile(this.activeProfile.id, targetName, true);
      }).catch(()=>{
        reject();
      });
    }
  }

  validateProfile(){
    this.message = ''
    let tokenValidity,
    isTokensEnabled, cookieMaxage;
    if (this.infoMap.db) {
      let index = -1
      forEach(this.infoMap.db,(database) => {
        index++
        if(database.dataSourceType.value === 'WM_MANAGED_DATASOURCE'){
          if (!database.url.value.split(this.dbUrl[index].prefix)[1]) {
            this.showErrorMsg('MESSAGE_ERROR_CONNECTION_URL');
            return;
          }else if (!database.username.value) {
            this.showErrorMsg('MESSAGE_ERROR_USERNAME');
            return;
          }else if (!database.password.value) {
            this.showErrorMsg('MESSAGE_ERROR_PASSWORD');
            return;
          }
        if (!database.minPoolSize.value || database.minPoolSize.value < 0) {
          this.showErrorMsg('MESSAGE_ERROR_POOL_MIN');
          return;
        }
        if (!database.maxPoolSize.value || database.maxPoolSize.value < 1) {
          this.showErrorMsg('MESSAGE_ERROR_POOL_MAX');
          return;
        }
        if (database.minPoolSize.value > database.maxPoolSize.value) {
          this.showErrorMsg('MESSAGE_ERROR_INCORRECT_POOL_SIZE');
          return;
        }
        }else if(database.dataSourceType.value === 'JNDI_DATASOURCE'){
        if (!database.jndiName.value?.split('java:')[1]) {
          this.showErrorMsg('MESSAGE_ERROR_JNDI_NAME');
          return;
        }
      }

        if (!database.maxPageSize.value || database.maxPageSize.value < 0) {
          this.showErrorMsg('MESSAGE_ERROR_RECORDS_MAX');
          return;
        }
        database.maxPageSize.value = database.maxPageSize.value >= 0 ? database.maxPageSize.value : "";
        database.maxPoolSize.value = database.maxPoolSize.value || "";
        database.minPoolSize.value = database.minPoolSize.value >= 0 ? database.minPoolSize.value : "";
      });
      if (this.message) {
        return;
      }
    }
    if (this.infoMap.security) {
      tokenValidity = get(this.infoMap, 'security.general["tokenService.tokenValiditySeconds"].value');
      isTokensEnabled = get(this.infoMap, 'InfoMap.security.general["tokenService.enabled"].value');
      if (isTokensEnabled && (!( tokenValidity >= 0 && tokenValidity <= 999 * 60) || (this.developmentMode && isNull(this.developmentMode.tokenValidity)))) {
        this.showErrorMsg('MESSAGE_ERROR_INCORRECT_VALID_TOKEN_TIME');
        return;
      }
      cookieMaxage = get(this.infoMap, 'security.general["cookie.maxAge"].value');
      if (isNull(cookieMaxage)) {
        this.showErrorMsg('MESSAGE_ERROR_COOKIE_MAXAGE');
        return;
      }

       // Truststore Config
       const TustStore_File_Type  = this.infoMap.security.general['truststore.file']?.value?.split('.').pop()?.toLowerCase();
        const fileTypeExtensions: { [key: string]: string[] } = {
          JKS: ['jks'],
          PKCS12: ['p12', 'pfx'],
          JCEKS: ['jceks']
        };
    const allowedExtensions = fileTypeExtensions[this.infoMap.security.general['truststore.fileType']?.value] || [];

    if(this.infoMap.security.general['truststore.config']?.value === 'APPLICATION_ONLY' ||this.infoMap.security.general['truststore.config']?.value === 'APPLICATION_AND_SYSTEM'){
      if(!this.infoMap.security.general['truststore.fileType'].value){
        this.showErrorMsg('MESSAGE_ERROR_TRUSTSTORE_UPLOAD_FILE_TYPE');
        return;
      }else if(!this.infoMap.security.general['truststore.file'].value){
        this.showErrorMsg('MESSAGE_ERROR_TRUSTSTORE_FILE');
        return;
      }else if (!TustStore_File_Type || !allowedExtensions.includes(TustStore_File_Type)) {
        let errorMsg = this.locale.MESSAGE_ERROR_TRUSTSTORE_FILETYPE.replace('${0}', this.infoMap.security.general['truststore.fileType'].value)
        this.message = { caption: errorMsg, type: 'error'};
        return;
      }else if(!this.infoMap.security.general['truststore.password'].value){
        this.showErrorMsg('MESSAGE_ERROR_TRUSTSTORE_PASSWORD');
        return;
      }
    }
    // Mtls Config
    const MTLS_File_Type = this.infoMap.security.general['mtls.keystore.file']?.value?.split('.').pop()?.toLowerCase();
    const mtlsAllowedExtensions = fileTypeExtensions[this.infoMap.security.general['mtls.keystore.fileType']?.value] || [];

    if(this.infoMap.security.general['mtls.enabled']?.value === 'true'){
      if(!this.infoMap.security.general['mtls.keystore.fileType'].value){
        this.showErrorMsg('MESSAGE_ERROR_MTLS_FILE_TYPE');
        return;
      }else if(!this.infoMap.security.general['mtls.keystore.file'].value){
        this.showErrorMsg('MESSAGE_ERROR_MTLS_FILE');
        return;
      }else if (!MTLS_File_Type || !mtlsAllowedExtensions.includes(MTLS_File_Type)) {
        let errorMsg = this.locale.MESSAGE_ERROR_TRUSTSTORE_FILETYPE.replace('${0}', this.infoMap.security.general['mtls.keystore.fileType'].value)
        this.message = { caption: errorMsg, type: 'error'};
        return;
      }else if(!this.infoMap.security.general['mtls.keystore.password'].value){
        this.showErrorMsg('MESSAGE_ERROR_MTLS_PASSWORD');
        return;
      }
    }
      if (this.infoMap.security.providers && this.infoMap.security.providers.saml) {
        if (this.infoMap.security.providers.saml.idpMetadataSource.value === 'URL') {
          if (!this.infoMap.security.providers.saml.idpMetadataUrl.value) {
            this.showErrorMsg('MESSAGE_SAML_IDP_METADATA_NOT_SET');
          }
        } else if (!this.metadataFile) {
          this.showErrorMsg('MESSAGE_SAML_EMPTY_METADATA_FILE');
        }
      }
      if (get(this.infoMap, 'security.general["frameOptions.mode"].value') !== 'ALLOW_FROM') {
        set(this.infoMap, 'security.general["frameOptions.allowFromUrl"].value', '');
      } else if (get(this.infoMap, 'security.general["frameOptions.enabled"].value') === "true" && !isValidXFrameUrls(get(this.infoMap, 'security.general["frameOptions.allowFromUrl"].value'))) {
        this.showErrorMsg(this.activeProfile.id === "development" ? 'MESSAGE_ERROR_ENTER_VALID_URL_X_FRAME' : 'MESSAGE_ERROR_ENTER_VALID_URL');
        return;
      }
      if(this.infoMap.security.session && this.infoMap.security.session['persistence.type'].value === 'redis') {
        if (isEmpty(this.infoMap.security.session['redis.host'].value)) {
          this.showErrorMsg('MESSAGE_REDIS_HOST_NOT_SET');
          return;
        }
        if (isEmpty(this.infoMap.security.session['redis.port'].value)) {
          this.showErrorMsg('MESSAGE_REDIS_PORT_NOT_SET');
          return;
        }
        if (isEmpty(this.infoMap.security.session['redis.database'].value)) {
          set(this.infoMap, 'security.session["redis.database"].value', '0');
        }
      }
      if(this.infoMap.security.session && this.infoMap.security.session['persistence.type'].value === 'mongodb') {
        if (isEmpty(this.infoMap.security.session['mongodb.host'].value)) {
          this.showErrorMsg('MESSAGE_MONGODB_HOST_NOT_SET');
          return;
        }
        if (isEmpty(this.infoMap.security.session['mongodb.port'].value)) {
          this.showErrorMsg('MESSAGE_MONGODB_PORT_NOT_SET');
          return;
        }
        if (isEmpty(this.infoMap.security.session['mongodb.username'].value)) {
          this.showErrorMsg('MESSAGE_MONGODB_USERNAME_NOT_SET');
          return;
        }
        if (isEmpty(this.infoMap.security.session['mongodb.password'].value)) {
          this.showErrorMsg('MESSAGE_MONGODB_PASSWORD_NOT_SET');
          return;
        }
        if (isEmpty(this.infoMap.security.session['mongodb.dbname'].value)) {
          this.showErrorMsg('MESSAGE_MONGODB_DBNAME_NOT_SET');
          return;
        }
      }
      if (this.message) {
        return;
      }
    }

    if(this.infoMap.rest){
      forEach(this.infoMap.rest,(rest) => {
        if (!rest.scheme.value) {
          this.showErrorMsg('MESSAGE_REST_PROTOCOL_NOT_SET');
          return;
           }else if(!rest.host.value){
        this.showErrorMsg('MESSAGE_REST_HOST_NOT_SET');
        return;
      }
      });
      if (this.message) {
        return;
      }
    }
    return true
  }

  hideMessage() {
    this.message = null;
  }

  showErrorMsg(msgkey: any) {
    this.message = {
      caption: this.locale[msgkey],
      type: 'error'
    };
  }

  // updates deployedUrl property on the current scope.
  updateDeployUrl() {
    let teamProjId = this.projectService.projectEdnDetails.projectId;
    if(teamProjId) {
      this.deployInProgress = true;
      (this.dpService.getContainerServicesDeployedUrl(teamProjId) as Promise<any>).then((response)=>{
            this.deployedUrl = response.result;
            this.deployInProgress = false;
      }).catch(()=>{
        this.deployInProgress = false;
      })
    }
  }

  editAppEnvironmentProperty() {
    this.newappEnvironmentParamsList = {};
    forEach(this.infoMap.app.environment, (value, key) => {
      this.newappEnvironmentParamsList['app.environment.' + key] = value.value;
    });
    this.isDisableSave = false;
  }

  deleteEnvironmentParams(key: any) {
    delete this.infoMap.app.environment[key];
    this.appEnvironmentInfo = this.infoMap.app.environment;
    this.newappEnvironmentParamsList = {};
    forEach(this.infoMap.app.environment, (value, key)=> {
      this.newappEnvironmentParamsList['app.environment.' + key] = value.value;
    });
    this.appEnvironmentUpdated = true;
    this.isDisableSave = false;
  }

  addNewEnvironmentParams() {
    this.errorKey = false;
    this.errorValue = false;
    if (!(this.appEnvironment.key && this.appEnvironment.value)) {
      this.errorKey = !this.appEnvironment.key;
      this.errorValue = !this.appEnvironment.value;
      this.notifyError(this.locale.MESSAGE_ERROR_NO_PROPERTIES);
      return;
    }
    if (!this.infoMap.app.environment) {
      this.infoMap.app.environment = {};
    }
    if (includes(keys(this.infoMap.app.environment), this.appEnvironment.key)) {
      this.notifyError(this.locale.MESSAGE_ERROR_DUPLICATE_PROPERTIES);
      return;
    }
    this.infoMap.app.environment[this.appEnvironment.key] = {
      autoUpdate: false,
      name: "app.environment." + this.appEnvironment.key,
      profileProperties: null,
      value: this.appEnvironment.value
    };
    this.newappEnvironmentParamsList = {};
    forEach(this.infoMap.app.environment, (value, key)=> {
      this.newappEnvironmentParamsList['app.environment.' + key] = value.value;
    });
    this.appEnvironmentUpdated = true;
    this.isDisableSave = false;
    this.appEnvironment.key = this.appEnvironment.value = '';
    this.appEnvironmentInfo = this.infoMap?.app?.environment;
  }

  updateAppEnvironmentProfile(resolve: any, reject: any) {
    this.notificationService.hide();
    if (this.existingParameters && isEqual(this.existingParameters, this.infoMap.app.environment)) {
      this.notifyInfo(this.locale.MESSAGE_INFO_NO_CHANGES_DETECTED);
      // setPristine();
      this.isDisableSave = true;
    }
    else {
      (this.dpService.appEnvironmentProfile(this.newappEnvironmentParamsList) as Promise<any>).then(() =>{
        this.errorKey = false;
        this.errorValue = false;
        this.existingParameters = ((this.infoMap && this.infoMap.app && this.infoMap.app.environment) ? getClonedObject(this.infoMap.app.environment) : {});
        this.isDisableSave = true;
        resolve();
        if(this.leaveProfileRoute) {
          return;
        }
        (this.dpService.appEnvironmentProperties() as Promise<any>).then((response)=>{
          let prop;
          if (response && response.length) {
            this.appEnvironmentProperties = {};
            forEach(response, (item)=> {
              if (startsWith(item, 'app.environment')) {
                prop = item.replace('app.environment.', '');
                this.appEnvironmentProperties[prop] = prop;
              }
            });
          }
          this.getProfile(this.activeProfile.id, undefined,true)
        })
      }).catch(()=>{
        this.isDisableSave = true;
        reject();
      })
    }
  }

  notifyError(message: string) {
    this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, message);
  }

  notifyInfo(message: string) {
    this.notificationService.show('info',this.locale.MESSAGE_INFO_TITLE, message);
  }

  notifySuccess(message: string) {
    this.notificationService.show('success', this.locale.MESSAGE_SUCCESS_TITLE, message);
  }

  copyToClipboard(event: any) {
    let $temp: any = $(event.target).closest('.form-group').find('input');
    $temp.select();
    document.execCommand('copy');
  }

  addRuntimeParams() {
    if (this.mode !== this.buildOptions.mode) {
      this.setProfileProperty('build.ui.mode', this.buildOptions.mode);
      this.buildOptions.angularBuildType = '--c=production';
      this.buildOptions.nodeMaxMemory = this.DEFAULT_NODE_MAX_MEMORY;
      this.setProfileProperty('build.ui.node.args', '--max-old-space-size=' + this.buildOptions.nodeMaxMemory);
      this.mode = this.buildOptions.mode;
    }
    this.setProfileProperty('build.ui.ng.config', this.buildOptions.angularBuildType);
  }

  setProfileProperty(name: any,value: any){
    let propExists = false;
    forEach(this.activeProfile.profileProperty,(profile)=>{
      if(profile.name===name){
        profile.value = value;
        propExists = true;
      }
    });
    if(!propExists){
      this.activeProfile.profileProperty.push({name:name,value:value});
    }
  }

  compareInfoMap(infoMap: any, storedInfoMap: any): boolean {
    const infoMapKey = Object.keys(infoMap);
    const storedInfoMapKey = Object.keys(storedInfoMap);

    if (infoMapKey.length !== storedInfoMapKey.length) {
      return false;
    }

    for (const key of infoMapKey) {
      if (!storedInfoMapKey.includes(key)) {
        return false;
      }

      const infoMapValue = infoMap[key];
      const storedInfoMapValue = storedInfoMap[key];

      if (typeof infoMapValue === 'object' && typeof storedInfoMapValue === 'object' && !isNull(infoMapValue) && !isNull(storedInfoMapValue)) {
        let stringifiedValueA = JSON.stringify(infoMapValue, (key, value) => (typeof value === 'number' ? value.toString() : value));
        let stringifiedValueB =  JSON.stringify(storedInfoMapValue, (key, value) => (typeof value === 'number' ? value.toString() : value));
        if (!this.compareInfoMap(JSON.parse(stringifiedValueA), JSON.parse(stringifiedValueB))) {
          return false;
        }
      } else if (infoMapValue !== storedInfoMapValue) {
        return false;
      }
    }
    return true;
  }

  registerWatchOnJNDI(nv:any){
    let jndi = nv.value,
    lastIndex,prefix_jndi = "java:";
        if (!nv) {
            return;
        }
      lastIndex = prefix_jndi.length;
      let obj = {
        _prefix_jndi : prefix_jndi,
        _suffix_jndi : jndi.substr(lastIndex)
      }
      this.jndiName.push(obj)
  }

}

